import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledUnhealthyLungsIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M14.283 14.1208V6.11536C14.283 4.76288 15.6992 3.87747 16.9151 4.46981C20.4817 6.20739 22.7447 9.82722 22.7447 13.7946V18.2813C22.7447 19.2053 21.931 19.9179 21.0151 19.7959L20.6638 19.7492C18.8355 19.5057 17.125 18.7097 15.7614 17.4676C14.8197 16.6097 14.283 15.3947 14.283 14.1208Z",
			fill: "#F9D5D3",
			stroke: "#E95550",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.46167 14.1208V6.11536C9.46167 4.76288 8.04542 3.87747 6.82955 4.46981C3.26294 6.20739 0.999895 9.82722 0.999895 13.7946V18.2813C0.999895 19.2053 1.81364 19.9179 2.72956 19.7959L3.08079 19.7492C4.90917 19.5057 6.6196 18.7097 7.98319 17.4676C8.92494 16.6097 9.46167 15.3947 9.46167 14.1208Z",
			fill: "#F9D5D3",
			stroke: "#E95550",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.98 1.78125V7.42243M11.98 7.42243L17.5 11.5921M11.98 7.42243L6.5 11.5M20.5 13L17.5 11.5921M17.5 11.5921L18.5 15.5M18.5 9.5L16.5 10.5M6.5 11.5L3.5 13M6.5 11.5L5.5 15.5M6.5 11.5L7.5 10.5L5.5 9.5",
			stroke: "#007AAF",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledUnhealthyLungsIcon);
const Memo = memo(ForwardRef);
export default Memo;
